import React, { useEffect, useState } from 'react';
import Select from 'components/Select';

const PhotoboothPicker = props => {
	const { auth0Token, event, photobooth, handlePickItem } = props;
	const [photobooths, setPhotobooths] = useState([]);
	const [selectedPhotobooth, setSelectedPhotoBooth] = useState([]);

	useEffect(() => {
		getPhotobooths();
	}, []);

	useEffect(() => {
		if (photobooth && photobooth.includes('photobooth') && !photobooth.includes('ai-photobooth')) {
			const photoboothKey = photobooth.split('/');
			const photoboothID = +photoboothKey[photoboothKey.length - 1];
			setSelectedPhotoBooth([photoboothID]);
		}
	}, [photobooth]);

	const getPhotobooths = async () => {
		const { id } = event;
		const isProd = import.meta.env.MODE === 'production';
		const configURL = isProd ? `https://ar.bpdev.club` : 'http://localhost:8005';

		const options = {
			headers: new Headers({
				'0Authorization': `Bearer ${auth0Token}`,
			}),
		};

		const res = await fetch(`${configURL}/api/assets/event/${id}`, options);

		if (res) {
			const { data } = await res.json();
			if (data) {
				setPhotobooths(data);
			}
		}
	};

	const handleSetPhotoboothRoute = sessionId => {
		const photobooth = photobooths.find(p => Number(p.id) === Number(sessionId));
		handlePickItem({
			route: `/photobooth/${sessionId}`,
			name: photobooth ? photobooth.camName : 'Photobooth',
		});
	};

	return (
		<div>
			<Select
				data={photobooths}
				value={selectedPhotobooth || []}
				onChange={handleSetPhotoboothRoute}
				placeholder="Select a photobooth"
				type="photobooth"
			/>
		</div>
	);
};

export default PhotoboothPicker;
